import { render, staticRenderFns } from "./CreateBongkar.vue?vue&type=template&id=24faad72&scoped=true&"
import script from "./CreateBongkar.vue?vue&type=script&lang=js&"
export * from "./CreateBongkar.vue?vue&type=script&lang=js&"
import style0 from "./CreateBongkar.vue?vue&type=style&index=0&id=24faad72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24faad72",
  null
  
)

export default component.exports